import React from "react";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getSupervisorKhattabatStore from "../../../../stores/supervisor-store/supervisor-khattabat-store";

const Form = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={true}
          onClick={async () => {
            await getSupervisorKhattabatStore().getAllRequiredData();
          }}
          size="LARGE"
          text="GET"
          type="GET"
        />
      </ET3Div>
    </React.Fragment>
  );
});

export default Form;
